module.exports = __webpack_public_path__ + "media/images/weather/203_night-349f512f61c487b873fd5c24be0ec405.png";